import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-vechain', 'BrandVechain', [["path",{"d":"M20 4l-8 16l-8 -16h2.028a4 4 0 0 1 3.578 2.211l2.894 5.789"}]]);